import React, { useMemo } from 'react';
import {
    usePropertyComplementaryData,
    usePropertyFetching,
    usePropertyRoomDetail,
} from '../../../contextsProperty/ContextProperties';
import Card from '../../../../muiComponents/Card';
import Tag from '../../../../muiComponents/Tag';
import '../../../../stylesheets/stylesLayout/yourProperties.scss';
import LoadingTab from '../LoadingTab';
import Title from '../Title';

export default function Beds() {
    const { bedTypes, toggleRoomItemInCollection } = usePropertyRoomDetail();
    const { bedsList } = usePropertyComplementaryData();
    const { isFetching } = usePropertyFetching();

    const visibleBeds = useMemo(() => {
        return bedTypes.filter(bed => !bed.Deleted);
    }, [bedTypes]);

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <div className='your-property__container'>
            <Title
                as='h1'
                text={'bed_types_title'}
                className='text-align-center'
            />
            <Card className='your-properties__form'>
                <div className='flex flex-center flex-wrap gap-20'>
                    {bedsList.map(option => {
                        const isChecked = visibleBeds.some(
                            bed => parseInt(bed.id) === parseInt(option.id)
                        );
                        return (
                            <Tag
                                key={option.id}
                                button
                                onClick={() => {
                                    toggleRoomItemInCollection(
                                        'bedTypes',
                                        option
                                    );
                                }}
                                size='large'
                                color='cyan'
                                variant={isChecked ? 'contrast' : 'surface'}
                                text={option.name}
                            />
                        );
                    })}
                </div>
            </Card>
        </div>
    );
}
